var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUgLogoSmall11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_83)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57_83",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.93457H0V10.9346H14V0.93457Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70077 10.9346H4.01477C3.47374 10.9346 2.94748 10.8305 2.45131 10.6246C1.97319 10.4261 1.54376 10.1424 1.1756 9.78193C0.80744 9.42096 0.518053 9.00045 0.316193 8.53113C0.106127 8.04464 0 7.52919 0 6.99819V2.659C0 1.71607 0.772429 0.937799 1.73359 0.93458C2.69748 0.931362 3.47976 1.69622 3.47976 2.64076V7.16339C3.47976 7.36185 3.64387 7.52276 3.84628 7.52276C4.05306 7.52276 4.22101 7.35809 4.22101 7.15535V2.65578C4.22101 1.96011 4.64497 1.339 5.30033 1.0735C5.95624 0.807998 6.7035 0.954962 7.20405 1.44735L7.23468 1.47846L13.523 7.9894C14.1838 8.67326 14.1537 9.7535 13.4557 10.4009C13.1193 10.7131 12.6893 10.8681 12.2598 10.8681C11.7987 10.8681 11.3381 10.6895 10.9962 10.3349L7.70077 6.92257V10.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3304 4.20747C13.2522 4.20747 13.9995 3.47481 13.9995 2.57102C13.9995 1.66723 13.2522 0.93457 12.3304 0.93457C11.4086 0.93457 10.6614 1.66723 10.6614 2.57102C10.6614 3.47481 11.4086 4.20747 12.3304 4.20747Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgLogoSmall11);
export default __webpack_public_path__ + "static/media/ug-logo-small 1 1.ed5f44a61e472e268319a7b4489162d1.svg";
export { ForwardRef as ReactComponent };